import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { AddPaymentModal } from '@widgets/AddPayments/ui/AddPaymentModal/AddPaymentModal';

import { fetchAccounts } from '../../store/slices/paymentSlice/action';

const getInitialApplicationsModalState = () => ({
    isOpen: false,
    mode: 'credit',
    step: 1,
    isBetweenAccount: false,
    isOpenPartners: false,
    addPaymentMode: 'applications',
});

export const ApplicationsPayment = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { accountsSelectList, archiveAccountList } = useSelector((state) => state.paymentReducer);

    const defaultAccount = accountsSelectList.find((account) => account.account.default_account);

    const [currentPayment, setCurrentPayment] = useState({});

    const [applicationsModalState, setApplicationsModalState] = useState(
        getInitialApplicationsModalState
    );

    const getPaymentRequestRoot = () => document.querySelector('#applications-react');

    const closePaymentRequestDetailsModal = () => {
        const $openedModal = $('.modalable-popup.show');

        if (!$openedModal.length) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            $openedModal.one('hidden.bs.modal', resolve);
            $.modalable('closeAll');
        });
    };

    const onSwitcherChange = () => {
        setApplicationsModalState((prevState) => ({
            ...prevState,
            isBetweenAccount: !prevState.isBetweenAccount,
        }));
    };
    const onHideAddModal = () => {
        setApplicationsModalState(getInitialApplicationsModalState());
    };

    const onHideModalPartner = () => {
        setApplicationsModalState((prevState) => ({ ...prevState, isOpenPartners: false }));
    };

    const submitHandler = async () => {
        loader.show();
        const paymentRequestRoot = getPaymentRequestRoot();
        const guid =
            paymentRequestRoot?.dataset.paymentRequestGuid ||
            $(document)
                .find('.modalable-popup')
                .find('[data-payment-request-guid]')
                .attr('data-payment-request-guid');
        const valueSum =
            paymentRequestRoot?.dataset.needToPaySum ||
            (await $(document)
                .find('#payment_request_details_popup')
                .find('form')
                .find('input')
                .prop('value'));

        if (!guid) {
            loader.hide();
            return;
        }

        const url = helpable.replaceUrlParameters(routable.getRoute('getPaymentRequestForReact'), {
            _guid_: guid,
        });

        const formData = new FormData();

        const parsedSum = numberFormatter.parseNumber(valueSum);
        const formattedSum = String(parsedSum);

        await formData.append('needToPaySum', formattedSum);
        const paymentRequestResponse = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        const paymentRequest = await paymentRequestResponse.json();

        if (paymentRequest.status === 'error') {
            swal({
                text: paymentRequest.message,
                cancel: true,
                confirm: false,
                button: {
                    text: t('button.got_it.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            loader.hide();
            return;
        }
        if (paymentRequest.errors) {
            const error = await $(document)
                .find('.react-error')
                .text(paymentRequest.errors[0].messages.join(''));

            error.show();
            loader.hide();
        }
        let paymentRequestAccount = await paymentRequest.data.account.guid;

        const isArchiveAccount = await archiveAccountList.some(
            (account) => account.account.guid === paymentRequestAccount
        );

        if (isArchiveAccount) {
            paymentRequestAccount = defaultAccount.value;
        }

        if (paymentRequest.errors) {
            const error = await $(document)
                .find('.react-error')
                .text(paymentRequest.errors[0].messages.join(''));

            error.show();
            await loader.hide();
        } else {
            const error = await $(document).find('.react-error').text('');
            error.hide();

            await setCurrentPayment({
                ...paymentRequest.data,
                sum: Number(formattedSum),
                account: { guid: paymentRequestAccount },
            });

            if (accountsSelectList.length) {
                await closePaymentRequestDetailsModal();
                setApplicationsModalState((prevState) => ({
                    ...prevState,
                    isOpen: true,
                    mode: 'credit',
                    step: 1,
                    isBetweenAccount: false,
                    isOpenPartners: false,
                    addPaymentMode: 'applications',
                }));
                loader.hide();
            } else {
                loader.show();
                await dispatch(fetchAccounts());
                await closePaymentRequestDetailsModal();
                setApplicationsModalState((prevState) => ({
                    ...prevState,
                    isOpen: true,
                    mode: 'credit',
                    step: 1,
                    isBetweenAccount: false,
                    isOpenPartners: false,
                    addPaymentMode: 'applications',
                }));
                loader.hide();
            }
        }
    };

    return (
        <>
            <button
                style={{ width: 0, height: 0, visibility: 'hidden' }}
                onClick={submitHandler}
                className="btn btn-primary ml-2"
                data-request-action-pay="pay"
            >
                {t('ApplicationsPayment.return.button.pay')}
            </button>
            {applicationsModalState.isOpen && (
                <AddPaymentModal
                    isOpen={applicationsModalState.isOpen}
                    onShowModal={onHideAddModal}
                    step={applicationsModalState.step}
                    modalState={applicationsModalState}
                    onHideModalPartner={onHideModalPartner}
                    onHideModal={onHideAddModal}
                    setModalState={setApplicationsModalState}
                    onSwitcherChange={onSwitcherChange}
                    mode="add"
                    payment={currentPayment}
                />
            )}
        </>
    );
};
